import { React, useEffect, useState } from "react";
import "../../../styles/desktop/alarmes.css";

const Alarmes = ({ alarmesStatus }) => {
    const [alarmeState, setAlarmeStates] = useState({
        alarme1: false,
        alarme2: false,
    });

    useEffect(() => {
        const updateState = () => {
            const alarme1Status = alarmesStatus.find((al) => al.idx === 4)?.state || false;
            const alarme2Status = alarmesStatus.find((al) => al.idx === 8)?.state || false;

            setAlarmeStates({
                alarme1: alarme1Status,
                alarme2: alarme2Status,
            });
        };

        updateState();
    }, [alarmesStatus]); // Atualizar apenas quando alarmesStatus mudar

    return (
        <div className="GrupoAlarmes">
            <div className="campoBomba">
                <div className="campoBombaAlarme">
                    <div id="alarme1" className="alarme">
                        <p className="titleAlarme">Bomba de incêndio San Marino</p>
                        <div className={alarmeState.alarme1 ? "alertCircle" : "circleAlarm"} id="circleAlarme1">
                            <p>{alarmeState.alarme1 ? "Defeito" : "Ligada"}</p>
                        </div>
                    </div>
                    <div id="alarme2" className="alarme">    
                        <p className="titleAlarme">Bomba de incêndio Positano</p>
                        <div className={alarmeState.alarme2 ? "alertCircle" : "circleAlarm"} id="circleAlarme2">
                            <p>{alarmeState.alarme2 ? "Defeito" : "Ligada"}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Alarmes;